/**
 * Trigger the resize event to load responsive images.
 */
function triggerResize() {
  const resize = document.createEvent('Event');
  resize.initEvent('resize', true, true);
  window.dispatchEvent(resize);
}

export default triggerResize;